import { generateUuidV4Regex } from "@/common/helpers/utils";
import { NotFoundView } from "@/views/common/notfound.view";
import { CustomerDetailView } from "@/views/customer-detail/customer-detail.view";
import { Route, Switch } from "wouter";
import { CustomerView } from "./customer.view";

export const CustomerRoutes = () => {
  const customerDetailUuidRegex = generateUuidV4Regex({ paramName: "uuid" });

  return (
    <Switch>
      <Route path={"/"} component={CustomerView} />
      <Route path={customerDetailUuidRegex} component={CustomerDetailView} />
      <Route component={NotFoundView} />
    </Switch>
  );
};
